import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import { GUEST_ALL, GUEST_LIST } from '../constants/actionTypes'
import * as API from '../constants/api'

export const guestAll = createAsyncThunk(
  GUEST_ALL,
  async (params: PayloadCreatorParams<`${typeof API.USER_GUEST_ALL}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.guestAll(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const guestList = createAsyncThunk(
  GUEST_LIST,
  async (params: PayloadCreatorParams<`${typeof API.USER_GUEST}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.guestList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const guestListClear = createAction(`${GUEST_LIST}/clear`)

export const guestAllClear = createAction(`${GUEST_ALL}/clear`)
